import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover } from "antd";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export interface ActionButtonProps {
  label: string;
  icon: IconProp;
  onClick: () => void;
  dataTestId?: string;
}

const ActionButton = ({ label, icon, onClick, dataTestId }: ActionButtonProps) => {
  return (
    <button type="button" className="multi-actions--item" data-testid={dataTestId} onClick={onClick}>
      <FontAwesomeIcon icon={icon} fixedWidth={true} size="lg" />
      <span className="multi-actions--label">{label}</span>
    </button>
  );
};

interface MultiActionsMenuProps {
  actionsConfig: ActionButtonProps[];
  triggerDataTestId?: string;
}

interface MultiActionsMenuState {
  isVisible: boolean;
}

export class MultiActionsMenu extends React.Component<MultiActionsMenuProps, MultiActionsMenuState> {
  static defaultProps: MultiActionsMenuProps = { actionsConfig: [] };
  private readonly ref = React.createRef<HTMLDivElement>();
  constructor(props: MultiActionsMenuProps) {
    super(props);
    this.state = {
      isVisible: false,
    };
  }

  toggleVisible = () => {
    this.setState({ isVisible: !this.state.isVisible });
  };

  handlePopupClick = (e: Event) => {
    if (this.ref.current.contains(e.target as Node)) {
      return;
    }
    this.setState({ isVisible: false });
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handlePopupClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handlePopupClick, false);
  }

  handleClick = (idx: number) => {
    this.toggleVisible();
    const { actionsConfig } = this.props;
    return actionsConfig[idx] && actionsConfig[idx].onClick && actionsConfig[idx].onClick();
  };

  get content() {
    return (
      <div className="multi-actions">
        {this.props.actionsConfig.map(({ icon, label, dataTestId }, idx) => (
          <ActionButton
            key={idx}
            icon={icon}
            label={label}
            dataTestId={dataTestId}
            onClick={() => this.handleClick(idx)}
          />
        ))}
      </div>
    );
  }

  getPopupContainer = () => {
    return this.ref.current;
  };

  render() {
    return (
      <Popover
        getPopupContainer={this.getPopupContainer}
        open={this.state.isVisible}
        placement={"bottomLeft"}
        content={this.content}
        styles={{ root: { width: 320 } }}
      >
        <div className="multi-actions--wrap" ref={this.ref}>
          <button
            type="button"
            className="multi-actions--trigger"
            data-testid={this.props.triggerDataTestId}
            onClick={this.toggleVisible}
            aria-label={"actions"}
            aria-expanded={this.state.isVisible}
            aria-haspopup="menu"
          >
            <FontAwesomeIcon icon={["fas", "th"]} fixedWidth={true} size="lg" />
          </button>
        </div>
      </Popover>
    );
  }
}
